import React from "react";
import "./ElapsedTimer.css";

const G = window.glob;

const ElapsedTimer = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = G.generateUid('ElapsedTimer');
		this.update = this.update.bind(this);
	}
	componentDidMount() {
		G.register('ElapsedTimer',e => {
			if ( ! e?.timer ) return this.setState({ timer: false });
			this.setState({
				time: e.time,
				timer: e.timer,
				stopped: !! e.stopped
			}, ()=>{ this.update() });
		}, this.uid);
	}
	componentWillUnmount() {
		G.deregister( this.uid );
	}
	update() {
		if ( ! this.state.timer ) return this.setState({ current: false });
		if ( this.state.update ) try { window.clearTimeout( this.state.update ) } catch(e){}
		let secs = Math.floor((((new Date().getTime()) - this.state.time) + this.state.timer)/1000);
		const hs = Math.floor(secs / 3600);
		secs = secs % 3600;
		const ms = Math.floor(secs / 60);
		secs = secs %60;
		const current = String(hs).padStart(2,'0').split('').map( (x,i) => <span key={'h'+i}>{x}</span> )
			.concat( [ <span key="a" className={"sep"}>:</span>] )
			.concat( String(ms).padStart(2,'0').split('').map( (x,i) => <span key={'m'+i}>{x}</span> ) )
			// .concat( [ <span key="b" className={"sep"}>:</span>] )
			// .concat( String(secs).padStart(2,'0').split('').map( (x,i) => <span key={'s'+i}>{x}</span> ) )
		;
		this.setState({
			current: current,
			update: this.state.stopped ? false : window.setTimeout( ()=>{ this.update() }, 10000 )
		})
	}
	render() {
		if ( ! this.state.timer ) return "";
		if ( ! this.state.current ) return "";
		return(
			<div className={"ElapsedTimer"} id={this.uid}>
				<div className={"value"+(this.state.stopped ? ' stopped' : '')}>
					{ this.state.current }
				</div>
			</div>
		);
	}
}

export default ElapsedTimer;